import React from "react";
import { Hero } from "./Hero";
import { Stats } from "./Stats";
import { About } from "./About";
import { Services } from "./Services";
import { Industries } from "./Industries";
import { Pricing } from "./Pricing";
import { WhyUs } from "./WhyUs";
import { Process } from "./Process";
import { Testimonials } from "./Testimonials";
import { FAQ } from "./FAQ";
import { Contact } from "./Contact";

export const Landing = () => (
  <main>
    <Hero />
    <Stats />
    <About />
    <Services />
    <Industries />
    <Pricing />
    <WhyUs />
    <Process />
    <Testimonials />
    <FAQ />
    <Contact />
  </main>
);
